<template>
  <v-dialog
    v-model="dialog"
    max-width="90vh"
    scrollable
    :retain-focus="false"
    persistent
  >

    <v-card height="100%">
      <v-toolbar color="primary" dark>{{ titleForm }}</v-toolbar>
      <v-divider></v-divider>

      <v-card-text>
        <v-row class="mt-3">
          <v-col cols="12" md="4">
            <v-text-field
              label="Starting Miles"
              v-model="newStarting"
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              label="Ending Miles"
              v-model="newEnding"
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              label="Total Miles"
              v-model="newTotal"
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-menu
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
              :nudge-top="20"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="newDate"
                  label="Date"
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  readonly
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="newDate"
                :min="minDate"
                :max="maxDate"
                no-title
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              label="Reimbursment Amount"
              prefix="$"
              v-model="newAmount"
              outlined
              :hint="`Remaining Balance ${balance}`"
              type="number"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row class="mt-n5">
          <v-col cols="12" md="12">
            <v-textarea outlined label="Notes" v-model="newNotes"></v-textarea>
          </v-col>
        </v-row>

        <v-row class="mt-1">
          <v-col cols="12" md="12">
            <form enctype="multipart/form-data">
              <v-file-input
                :placeholder="newReceipt"
                label="Upload Receipt"
                prepend-icon="mdi-camera"
                accept="image/*"
                @change="imgSelected"
                outlined
              ></v-file-input>
              <template>
                <v-card class="pa-3 mb-2" v-show="newReceiptImage">
                  <v-img :src="newReceiptImage" height="300" contain></v-img>
                </v-card>
              </template>
            </form>
          </v-col>
        </v-row>

        <v-row class="mt-n8">
          <v-col cols="12" md="12">
            <v-checkbox
              v-model="checkedSignature"
              label="Signature"
              hide-details
              @change="addSignature($event)"
            ></v-checkbox>
            <v-text-field v-model="newSignature"></v-text-field>
          </v-col>
        </v-row>

      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          class="white--text"
          :color="editMileage ? 'blue darken-1' : '#259647'"
          @click="editMileage ? onUpdateItem() : onAddItem()"
        >
          <div class="text-caption text-sm-body-1">
            {{ editMileage ? "Update" : "Save" }}
          </div>
        </v-btn>
        <v-btn color="blue darken-1" text @click="close">
          <div class="text-caption text-sm-body-1">Cancel</div></v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/*eslint-disable */
import axios from "axios";
import moment from "moment";
import { mapActions, mapGetters } from "vuex";
const url = require("../../client_config/config").url;

export default {
  props: ["mileageData", "currentBalance"],
  components: {
    
  },
  data() {
    return {
      newItem: false,
      newDate: "",
      newAction: "",
      newTransactionMethods: "",
      newType: "",
      newStarting: "",
      newEnding: "",
      newTotal: "",
      calcTotal: "",
      newAmount: "",
      newNotes: "",
      newSignature: "",
      signaturepop2: false,
      newBalance: 0,
      newSigned: "",
      newReceipt: "",
      newReceiptImage: "",
      newMileage: false, 
      titleForm: "New Mileage Entry",
      uploadImg: "",
      mileageID: "",
      staffID: localStorage.getItem("staffId"),
      staff: localStorage.getItem("Name"),
      msg: false,
      text: "",
      signed: false,
      editMileage: false,
      maxDate: "",
      minDate: "",
      balance: this.currentBalance,    
    };
  },

  async created() {
    await this.getMileages(this.staffID);
    this.setDate();
  },

  computed: {
    ...mapGetters(["getMileageData", "mileageDate"]),

    dialog: {
      get() {
        return this.$store.state.mileages.showNewMileage;
      },
      set(val) {
        this.$store.commit("SET_NEW_MILEAGES", val);
      },
    },
  },

   watch: {
    'newEnding': function(nval){
      this.newEnding = nval
      this.newTotal = (parseInt(nval) - parseInt(this.newStarting))
      this.newAmount = (parseInt(this.newTotal) * (parseFloat(.42)*100)/100).toFixed(2)
    },
    
  },

  methods: {
    ...mapActions(["getMileages"]),
    // signatureData(data) {
    //   this.newClientSignature = data;
    // },

    async setDate() {
      const filterTransactionDate = await this.getMileageData.find(
        (item) => item._id === this.$route.params.mileageID
      );

      this.minDate = moment(new Date(filterTransactionDate?.Date))
        .startOf("month")
        .format("YYYY-MM-DD");

      this.maxDate = moment(new Date(filterTransactionDate?.Date))
        .endOf("month")
        .format("YYYY-MM-DD");

      this.newDate = moment(new Date(filterTransactionDate?.Date)).format(
        "YYYY-MM-DD"
      );
    },

    onViewItem(item) {
      this.mileageID = item._id;
      this.editMileage = true;
      this.newDate = moment(new Date(item.Date)).format("YYYY-MM-DD");
      this.newStarting = item.Starting;
      this.newEnding = item.Ending;
      this.newTotal = item.Total;
      this.newAmount = item.Amount;
      this.newNotes = item.Notes;
      this.newSigned = item.Signed;
      this.newSignature = item.StaffSignature
        ? ((this.checkedSignature = true), item.StaffSignature)
        : ((this.checkedSignature = false), "");
      this.newReceipt = item.Receipt?.Name || "";
      if (item.Receipt !== "") {
        this.newReceiptImage = item.Receipt?.AWSLink || "";
      }
    },
    async onAddItem() {
      var total = "";
      console.log(this.balance + "nbalance")
      console.log(this.newAmount + " amount")
      total = (parseInt(this.balance) + parseInt(this.newAmount, 10));
      console.log(total)
      var req_body = {
        Date: this.newDate,
        Starting: this.newStarting,
        Ending: this.newEnding,
        Total: this.newTotal,
        Amount: this.newAmount,
        Balance: total,
        Notes: this.newNotes,
        StaffSignature: this.newSignature,
        Signed: this.newSigned,
        StaffID: this.staffID,
        MileageID: this.$route.params.mileageID,
      };

      this.$store.dispatch("addMileageTransaction", req_body).then((res) => {
        if (res.success) {
          this.mileageID = res._id;
          this.saveImg();
          this.$store.dispatch("updateMileageBalance", {
            id: this.$route.params.mileageID,
            Amount: total,
          });
        }
      });

      this.close();
    },

    onUpdateItem() {
      var req_body = {
        Date: this.newDate,
        Starting: this.newStarting,
        Ending: this.newEnding,
        Total: this.newTotal,
        Amount: this.newAmount,
        Notes: this.newNotes,
        StaffSignature: this.newSignature,
        Signed: this.newSigned,
      };

      this.$store
        .dispatch("updateMileageTransaction", { req_body, id: this.mileageID })
        .then((res) => {
          console.log("dispatch", res);
        });

      this.saveImg();
      this.close();
    },

    addSignature(e) {
      if (!e) return (this.newSignature = "");
      this.newSignature = this.staff + " - " + new Date();
      this.signed = true;
    },

    close() {
      this.dialog = false;
      this.editMileage = false;
      this.clear();
    },

    imgSelected(e) {
      this.uploadImg = e;
    },

    async saveImg() {
      if (
        this.uploadImg !== null &&
        this.uploadImg !== undefined &&
        this.uploadImg !== ""
      ) {
        const formData = new FormData();
        formData.append("receipt-img", this.uploadImg);
        var ct = { headers: { "content-type": "multipart/form-data" } };
        await axios
          .post(
            `${url}/mileageTransactions/imguploader/${this.mileageID}/${this.staffID}`,
            formData,
            ct
          )
          .then((res) => {
            if (res) {
             
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },

    clear() {
      this.newDate = "";
      this.newAmount = "";
      this.newStarting = "";
      this.newEnding = "";
      this.newTotal = "";
      this.newNotes = "";
      this.newPayee = "";
      this.newSignature = "";
      this.newSigned = "";
      this.newReceipt = "";
      this.newReceiptImage = "";
      this.rules = [];
    },
  },
};
</script>
